import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DropdownModule} from 'primeng/dropdown';
import {FormsModule} from '@angular/forms';
import {BulkTaxReportComponent} from "./bulk-tax-report.component";
import {BulkTaxReportRoutingModule} from "./bulk-tax-report-routing.module";
import {AutoCompleteModule, CalendarModule, CheckboxModule, GrowlModule, MultiSelectModule} from "primeng/primeng";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CoreModule} from '../../core/core.module';
import {TableModule} from 'primeng/table';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    DropdownModule,
    FormsModule,
    CalendarModule,
    CheckboxModule,
    AutoCompleteModule,
    NgbModule,
    GrowlModule,
    CoreModule,
    TableModule,
    TranslateModule,
    // BulkTaxReportRoutingModule
    MultiSelectModule
  ],
  declarations: [BulkTaxReportComponent]
})
export class BulkTaxReportModule {
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/bulk-tax-report/bulk-tax-report.module.ts